export default __webpack_public_path__ + "static/media/report-enrolment-icon.711f36b0.svg";